import { motion } from "framer-motion";
import { fadeUp } from "@/lib/motion";

const STATUS = {
  done: { label: "On file", dot: "bg-white/40" },
  watching: { label: "We're watching", dot: "bg-cherry animate-pulse" },
  next: { label: "Ahead", dot: "border border-cherry/70 bg-transparent" },
};

export const CaseWatch = ({ entries }) => {
  if (!entries?.length) return null;
  return (
    <motion.div
      variants={fadeUp}
      data-testid="case-watch-panel"
      className="mt-12 rounded-3xl border border-white/10 bg-panel/60 p-7 sm:p-9"
    >
      <div className="flex items-center gap-3">
        <span className="relative flex h-2.5 w-2.5">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-cherry opacity-60" />
          <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-cherry" />
        </span>
        <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-cherry">Case Watch</p>
      </div>
      <p className="mt-2 text-[11px] uppercase tracking-[0.18em] text-white/35">
        The federal file — updated as the case moves.
      </p>
      <ol className="mt-8">
        {entries.map((entry, i) => {
          const s = STATUS[entry.status] || STATUS.done;
          return (
            <li
              key={i}
              data-testid={`case-watch-item-${i}`}
              className="relative flex gap-5 pb-8 last:pb-0"
            >
              <div className="flex flex-col items-center">
                <span className={`mt-1 h-3 w-3 shrink-0 rounded-full ${s.dot}`} />
                {i < entries.length - 1 && <span className="mt-1 w-px flex-1 bg-white/15" />}
              </div>
              <div className="flex-1">
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-white/40">
                  {entry.date} · {s.label}
                </p>
                <p className="mt-1 font-display text-base font-bold text-white/90 sm:text-lg">
                  {entry.title}
                </p>
                <p className="mt-1 text-sm leading-relaxed text-white/60">{entry.detail}</p>
              </div>
            </li>
          );
        })}
      </ol>
    </motion.div>
  );
};

export default CaseWatch;
